import { utils, writeFile } from 'xlsx';
import { saveAs } from 'file-saver';
import { datePad } from '@app/shared/utils';
import { FormatFileType } from './format-file-type.enum';
var Spreadsheet = /** @class */ (function () {
    function Spreadsheet(name, table, format) {
        if (format === void 0) { format = FormatFileType.EXCEL; }
        this.name = name;
        this.table = table;
        this.format = format;
    }
    Spreadsheet.prototype.generateSpreadsheet = function () {
        var workSheet = utils.json_to_sheet(this.table);
        var workBook = utils.book_new();
        utils.book_append_sheet(workBook, workSheet, this.name);
        writeFile(workBook, this.fileName);
    };
    Object.defineProperty(Spreadsheet.prototype, "fileName", {
        get: function () {
            var timestamp = new Date();
            var day = datePad(timestamp.getDate());
            var month = datePad(timestamp.getMonth() + 1);
            var hours = "" + timestamp.getHours();
            var minutes = "" + timestamp.getMinutes();
            var seconds = "" + timestamp.getSeconds();
            var dateFormat = "" + timestamp.getFullYear() + month + day;
            var hourFormat = "" + hours + minutes + seconds;
            return this.name + "-" + dateFormat + "-" + hourFormat + "." + this.format;
        },
        enumerable: true,
        configurable: true
    });
    Spreadsheet.prototype.generate = function (data) {
        if (window.navigator.msSaveOrOpenBlob) {
            window.navigator.msSaveBlob(data, this.fileName);
        }
        else {
            var blob = new Blob([data]);
            var file = new File([blob], this.fileName);
            saveAs(file);
        }
    };
    return Spreadsheet;
}());
export { Spreadsheet };
